module.exports = __webpack_public_path__ + "img/Icon material-dashboard.6d6dbbff.svg";